'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMdl = require('react-mdl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Dropdown = require('../Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _OptionList = require('../OptionList');

var _OptionList2 = _interopRequireDefault(_OptionList);

var _Option = require('../Option');

var _Option2 = _interopRequireDefault(_Option);

require('./AutoComplete.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AutoComplete = function (_Component) {
  _inherits(AutoComplete, _Component);

  function AutoComplete(props) {
    _classCallCheck(this, AutoComplete);

    var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this, props));

    _this.state = {
      value: null,
      focused: false
    };
    _this.onItemClick = _this.onItemClick.bind(_this);
    _this.onTextfieldChange = _this.onTextfieldChange.bind(_this);
    _this.onTextfieldFocus = _this.onTextfieldFocus.bind(_this);
    _this.onTextfieldBlur = _this.onTextfieldBlur.bind(_this);
    return _this;
  }

  _createClass(AutoComplete, [{
    key: 'onItemClick',
    value: function onItemClick(newValue) {
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;
      this.setState({
        value: null
      });

      if (value !== newValue && onChange) {
        onChange(newValue);
      }
    }
  }, {
    key: 'onTextfieldChange',
    value: function onTextfieldChange(e) {
      var _props2 = this.props,
          forceSelect = _props2.forceSelect,
          onChange = _props2.onChange;
      var value = e.target.value;
      this.setState({
        value: value
      });

      if (!forceSelect && onChange) {
        onChange(value);
      }
    }
  }, {
    key: 'onTextfieldFocus',
    value: function onTextfieldFocus() {
      var _props3 = this.props,
          value = _props3.value,
          onFocus = _props3.onFocus;
      this.setState({
        focused: true
      });
      if (onFocus) onFocus(value);
    }
  }, {
    key: 'onTextfieldBlur',
    value: function onTextfieldBlur() {
      var _props4 = this.props,
          value = _props4.value,
          onBlur = _props4.onBlur;
      this.setState({
        focused: false
      });
      if (onBlur) onBlur(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props5 = this.props,
          align = _props5.align,
          className = _props5.className,
          dataIndex = _props5.dataIndex,
          disabled = _props5.disabled,
          error = _props5.error,
          floatingLabel = _props5.floatingLabel,
          items = _props5.items,
          label = _props5.label,
          offset = _props5.offset,
          readOnly = _props5.readOnly,
          value = _props5.value,
          valueIndex = _props5.valueIndex;
      var _state = this.state,
          focused = _state.focused,
          stateValue = _state.value; // filter children

      var filtered = items;

      if (stateValue) {
        try {
          var regex = new RegExp(stateValue, 'i');
          filtered = items.filter(function (i) {
            return i[dataIndex].match(regex, 'g');
          });
        } catch (e) {
          filtered = [];
        }
      } // create options


      var children = filtered.map(function (item) {
        var value = item[valueIndex];
        var data = item[dataIndex];
        return _react2.default.createElement(_Option2.default, {
          key: value,
          value: value
        }, data);
      }); // calculate input value

      var item = items.find(function (item) {
        return item[valueIndex] === value;
      });
      var data = item && item[dataIndex] || '';
      var inputValue = typeof stateValue === 'string' ? stateValue : data; // calculate input props

      var inputProps = {
        disabled: disabled,
        error: error,
        floatingLabel: floatingLabel,
        label: label,
        readOnly: disabled,
        ref: function ref(_ref) {
          return _this2.input = _ref;
        },
        type: 'text',
        onChange: this.onTextfieldChange,
        value: inputValue || ""
      };

      if (!readOnly) {
        inputProps.onFocus = this.onTextfieldFocus;
        inputProps.onBlur = this.onTextfieldBlur;
      } // calculate main class


      var mainClass = (0, _classnames2.default)({
        'mdl-autocomplete': true,
        'mdl-autocomplete--disabled': disabled,
        'mdl-autocomplete--error': error,
        'mdl-autocomplete--focused': focused
      }, className); // render without dropdown

      if (disabled || readOnly) {
        return _react2.default.createElement('div', {
          className: mainClass
        }, _react2.default.createElement(_reactMdl.Textfield, inputProps), _react2.default.createElement('i', {
          className: 'mdl-autocomplete__arrow'
        }));
      } // calculate dropdown props


      var dropdownProps = {
        align: align,
        offset: offset,
        target: _react2.default.createElement(_reactMdl.Textfield, inputProps),
        useTargetWidth: true // render with dropdown

      };
      return _react2.default.createElement('div', {
        className: mainClass
      }, _react2.default.createElement(_Dropdown2.default, dropdownProps, _react2.default.createElement(_OptionList2.default, {
        value: value,
        onItemClick: this.onItemClick
      }, children)), _react2.default.createElement('i', {
        className: 'mdl-autocomplete__arrow'
      }));
    }
  }]);

  return AutoComplete;
}(_react.Component);

AutoComplete.propTypes = {
  align: _propTypes2.default.string,
  className: _propTypes2.default.string,
  dataIndex: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool,
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  floatingLabel: _propTypes2.default.bool,
  forceSelect: _propTypes2.default.bool,
  items: _propTypes2.default.array.isRequired,
  label: _propTypes2.default.string.isRequired,
  offset: _propTypes2.default.string,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  readOnly: _propTypes2.default.bool,
  showMenuBelow: _propTypes2.default.bool,
  value: _propTypes2.default.any,
  valueIndex: _propTypes2.default.string.isRequired
};
AutoComplete.defaultProps = {
  align: 'tl bl',
  offset: '20px 0'
};
exports.default = AutoComplete;